module.exports = __webpack_public_path__ + "media/images/mobile/city_img/f-07191d72f9df75dcd030f454aaf99ea8.jpg";